import { I2cSpinner } from "@webcomponents/i2cwebcomponents/dist/react";
import "./Loader.scss";

export const OverlayLoader = ({
  size = "xxl",
  spinner = "dual-shade",
  hideSpinner = false,
  style = {},
}) => {
  return (
    <>
      <div style={style} className="loading-spinner" id="loadingSpinner">
        {!hideSpinner && (
          <I2cSpinner size={size} label="Loading..." spinner={spinner} />
        )}
      </div>
    </>
  );
};
